import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IRelationshipTypeHasRelationshipRole } from '../../Interfaces/IRelationshipTypeHasRelationshipRole';

const initialState = {
  storeRelationshipTypeHasRelationshipRole:
    [] as IRelationshipTypeHasRelationshipRole[],
};

const sliceRelationshipTypeHasRole = createSlice({
  name: 'RELATIONSHIPTYPEHASRELATIONSHIPROLE',
  initialState,
  reducers: {
    setRelationshipTypeHasRoleArray: (
      state,
      action: PayloadAction<IRelationshipTypeHasRelationshipRole[]>
    ) => {
      state.storeRelationshipTypeHasRelationshipRole = [...action.payload];
    },
    addUpdateRelationshipTypeRoleArray: (
      state,
      action: PayloadAction<IRelationshipTypeHasRelationshipRole>
    ) => {
      const testObject = state.storeRelationshipTypeHasRelationshipRole.find(
        x =>
          x.idRelationshipRole === action.payload.idRelationshipRole &&
          x.idRelationshipType === action.payload.idRelationshipType
      );

      if (testObject) {
        state.storeRelationshipTypeHasRelationshipRole = [
          ...state.storeRelationshipTypeHasRelationshipRole.map(x =>
            x.idRelationshipRole === action.payload.idRelationshipRole &&
            x.idRelationshipType === action.payload.idRelationshipType
              ? action.payload
              : x
          ),
        ];
      } else {
        state.storeRelationshipTypeHasRelationshipRole = [
          action.payload,
          ...state.storeRelationshipTypeHasRelationshipRole,
        ];
      }
    },
  },
});
export const {
  setRelationshipTypeHasRoleArray,
  addUpdateRelationshipTypeRoleArray,
} = sliceRelationshipTypeHasRole.actions;
export default sliceRelationshipTypeHasRole.reducer;
